import * as CONST from '../../constants';

const INITIAL_STATE = { loading: true, data: [], error: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.PLAN_DELIVERY_TIMES_REQUEST:
      return { ...INITIAL_STATE, loading: true };
    case CONST.PLAN_DELIVERY_TIMES_SUCCESS:
      return { ...INITIAL_STATE, loading: false, data: action.data.data };
    case CONST.PLAN_DELIVERY_TIMES_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error };
    default:
      return state;
  }
};
